<script setup lang="ts">
import FiatTransactionDetailContainer from './containers/FiatTransactionDetailContainer.vue'
</script>

<template>
  <FiatTransactionDetailContainer />
</template>
